/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Home_Waiting_NoneInputs */



/**
* | output |
* | --- |
* | "Every customer has signed in. Nothing is waiting on you." |
*
* @param {Partner_Home_Waiting_NoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_home_waiting_none = /** @type {((inputs?: Partner_Home_Waiting_NoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Home_Waiting_NoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Kunden haben sich angemeldet. Es wartet nichts auf Sie.")
	return /** @type {LocalizedString} */ ("Every customer has signed in. Nothing is waiting on you.")
});